module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book.component.scss
// module id = ./src/app/book/book.component.scss
// module chunks = main